// 🎨 Sistema cromático universal EPL - InnovaTech Lab 1
// 📋 Basado en EPL_UX_UI_POLICY.md v1.0

/**
 * Colores por fase del laboratorio según Policy EPL
 */
export const EPL_PHASE_COLORS = {
  // Fase 0: Contexto - Orientar
  contexto: {
    primary: '#1E293B',
    gradient: 'from-slate-800 to-slate-600', 
    background: '#F1F5F9',
    text: '#FFFFFF',
    border: 'border-slate-600',
    cognitive: 'Orientar'
  },
  
  // Fase 1: Hipótesis Central (BUILD) - Crear  
  hipotesis: {
    primary: '#2563EB',
    gradient: 'from-blue-600 to-blue-400',
    background: '#DBEAFE', 
    text: '#FFFFFF',
    border: 'border-blue-600',
    cognitive: 'Crear'
  },
  
  // Fase 2: BML Build - Crear
  bml_build: {
    primary: '#2563EB',
    gradient: 'from-blue-600 to-blue-400',
    background: '#DBEAFE',
    text: '#FFFFFF', 
    border: 'border-blue-600',
    cognitive: 'Crear'
  },
  
  // Fase 3: BML Measure - Analizar
  bml_measure: {
    primary: '#0EA5E9',
    gradient: 'from-sky-500 to-cyan-400',
    background: '#E0F2FE',
    text: '#FFFFFF',
    border: 'border-sky-500', 
    cognitive: 'Analizar'
  },
  
  // Fase 4: Simulate - Experimentar
  bml_simulate: {
    primary: '#10B981', 
    gradient: 'from-emerald-500 to-green-400',
    background: '#D1FAE5',
    text: '#FFFFFF',
    border: 'border-emerald-500',
    cognitive: 'Experimentar'
  },
  
  // Fase 5: Learn/Decide - Reflexionar  
  bml_learn: {
    primary: '#8B5CF6',
    gradient: 'from-violet-500 to-purple-400', 
    background: '#EDE9FE',
    text: '#FFFFFF',
    border: 'border-violet-500',
    cognitive: 'Reflexionar'
  },
  
  // Fase 6: Quiz/Evaluación - Evaluar
  quiz: {
    primary: '#F59E0B',
    gradient: 'from-amber-500 to-yellow-400',
    background: '#FEF3C7', 
    text: '#FFFFFF',
    border: 'border-amber-500',
    cognitive: 'Evaluar'
  },
  
  // Fase 7: Resumen - Cerrar
  resumen: {
    primary: '#16A34A',
    gradient: 'from-green-600 to-emerald-400',
    background: '#DCFCE7',
    text: '#FFFFFF', 
    border: 'border-green-600',
    cognitive: 'Cerrar'
  }
};

/**
 * Estados IA y globales según Policy EPL
 */
export const EPL_IA_COLORS = {
  active: '#6F3FF5',      // IA activa - botones "Validar con IA"
  passive: '#A78BFA',     // IA pasiva - recomendaciones
  success: '#22C55E',     // Validaciones aprobadas
  warning: '#EAB308',     // Necesita revisión
  error: '#EF4444',       // Errores cognitivos
  neutral: '#CBD5E1'      // Elementos sin interacción
};

/**
 * Tipos de tooltip según Policy EPL
 */
export const EPL_TOOLTIP_COLORS = {
  ui: { bg: '#1E293B', text: '#FFFFFF' },        // Neutro
  ia: { bg: '#6F3FF5', text: '#FFFFFF' },        // IA violeta  
  pedagogico: { bg: '#10B981', text: '#FFFFFF' }, // Coach verde
  alerta: { bg: '#FACC15', text: '#000000' }     // Advertencias
};

/**
 * Helper: Obtener colores por fase
 */
export const getPhaseColors = (phaseKey) => {
  return EPL_PHASE_COLORS[phaseKey] || EPL_PHASE_COLORS.contexto;
};

/**
 * Helper: Obtener gradiente por fase  
 */
export const getPhaseGradient = (phaseKey) => {
  const colors = getPhaseColors(phaseKey);
  return `bg-gradient-to-r ${colors.gradient}`;
};

/**
 * Helper: Obtener clases Tailwind completas
 */
export const getPhaseStyles = (phaseKey) => {
  const colors = getPhaseColors(phaseKey);
  return {
    header: `bg-gradient-to-r ${colors.gradient} text-white`,
    background: colors.background,
    border: colors.border,
    primary: colors.primary
  };
};